import React, { ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';

interface ColumnsProps {
    children: Array<ReactElement<ColumnProps> | null> | ReactElement<ColumnProps> | null;
    grid?: boolean;
}

interface ColumnProps {
    children: React.ReactNode;
    width?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
}

// TODO: Look at using the Matrix layout component from @99designs/emu instead
export const Columns = styled.div<ColumnsProps>(({ children, grid = true }) => {
    const columnsCount = React.Children.count(children);
    const baseColumnsCount = grid ? 12 : columnsCount;

    return css`
        display: grid;
        grid-template-columns: repeat(${baseColumnsCount}, 1fr);

        ${grid &&
        css`
            grid-column-gap: ${spaces['1bu']};

            ${mediaQuery.minimum('medium')} {
                grid-column-gap: ${spaces['2bu']};
            }
        `}

        ${Column} {
            grid-column-start: span ${Math.floor(baseColumnsCount / columnsCount)};
        }
    `;
});

export const Column = styled.div<{ width?: number[] }>(({ width }) => {
    if (width) {
        return css`
            grid-column-start: span ${width[0]} !important;

            ${mediaQuery.only('medium')} {
                grid-column-start: span ${width[1]} !important;
            }

            ${mediaQuery.only('normal')} {
                grid-column-start: span ${width[2]} !important;
            }

            ${mediaQuery.only('large')} {
                grid-column-start: span ${width[3]} !important;
            }
        `;
    } else {
        return css``;
    }
});

Column.displayName = 'Column';
